export default {
  iOS: [
    {
      majorVersion: "7.0",
      majorUpdates: [
        {
          file: "menu7.json",
          diff: {},
          diffCreatedBy: null,
          pushedToStage: false,
          pushedToProd: false,
          approved: false,
          approvedBy: null,
        },
        {
          file: "schedule7.json",
          diff: {},
          diffCreatedBy: null,
          pushedToStage: false,
          pushedToProd: false,
          approved: false,
          approvedBy: null,
        },
      ],
      data: {
        files: ["menu7.json", "schedule7.json"],
        minorVersions: [
          {
            version: "7.0.1",
            updates: [
              {
                file: "menu701.json",
                diff: {},
                diffCreatedBy: null,
                pushedToStage: false,
                pushedToProd: false,
                approved: false,
                approvedBy: null,
              },
              {
                file: "schedule701.json",
                diff: {},
                diffCreatedBy: null,
                pushedToStage: false,
                pushedToProd: false,
                approved: false,
                approvedBy: null,
              },
            ],
          },
          {
            version: "7.0.2",
            updates: [],
          },
        ],
      },
    },
    {
      majorVersion: "6.0",
      majorUpdates: [],
      data: {
        files: ["menu6.json", "schedule6.json"],
        minorVersions: [
          {
            version: "6.0.1",
            updates: [],
          },
          {
            version: "6.0.2",
            updates: [
              {
                file: "menu602.json",
                diff: {},
                diffCreatedBy: null,
                pushedToStage: false,
                pushedToProd: false,
                approved: false,
                approvedBy: null,
              },
              {
                file: "schedule602.json",
                diff: {},
                diffCreatedBy: null,
                pushedToStage: false,
                pushedToProd: false,
                approved: false,
                approvedBy: null,
              },
            ],
          },
        ],
      },
    },
  ],
  Android: [
    {
      majorVersion: "11.0",
      majorUpdates: [],
      data: {
        files: ["menu.json", "schedule.json"],
        minorVersions: [
          {
            version: "11.0.1",
            updates: [],
          },
          {
            version: "11.0.2",
            updates: [
              {
                file: "menu.json",
                diff: {},
                diffCreatedBy: null,
                pushedToStage: false,
                pushedToProd: false,
                approved: false,
                approvedBy: null,
              },
              {
                file: "schedule.json",
                diff: {},
                diffCreatedBy: null,
                pushedToStage: false,
                pushedToProd: false,
                approved: false,
                approvedBy: null,
              },
            ],
          },
        ],
      },
    },
    {
      majorVersion: "10.0",
      majorUpdates: [
        {
          file: "menu.json",
          diff: {},
          diffCreatedBy: null,
          pushedToStage: false,
          pushedToProd: false,
          approved: false,
          approvedBy: null,
        },
        {
          file: "schedule.json",
          diff: {},
          diffCreatedBy: null,
          pushedToStage: false,
          pushedToProd: false,
          approved: false,
          approvedBy: null,
        },
      ],
      data: {
        files: ["menu.json", "schedule.json"],
        minorVersions: [
          {
            version: "10.0.1",
            updates: [
              {
                file: "menu.json",
                diff: {},
                diffCreatedBy: null,
                pushedToStage: false,
                pushedToProd: false,
                approved: false,
                approvedBy: null,
              },
              {
                file: "schedule.json",
                diff: {},
                diffCreatedBy: null,
                pushedToStage: false,
                pushedToProd: false,
                approved: false,
                approvedBy: null,
              },
            ],
          },
          {
            version: "10.0.2",
            updates: [],
          },
        ],
      },
    },
  ],
}
